import { gql } from '@apollo/client';

export const NEW_USER = gql`
  fragment SignUp on User {
    id
    email
    name
    surName
    rolActive
    concessionIDs
    teamIDs
    internal
    isActive
    userType
  }
`;
